import React, { useEffect } from 'react';
import { X } from 'react-feather';
import { BRAND_COLORS } from '@/UIlibrary/globalTheme';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface DeliberationDrawerProps {
	isOpen: boolean;
	onClose: () => void;
	t: any;
	deliberation: string;
	isResizing: boolean;
	drawerWidth: number;
	onResizingChange: (isResizing: boolean) => void;
	onDrawerWidthChange: (width: number) => void;
	onSuccess?: () => void;
}

const DeliberationDrawer: React.FC<DeliberationDrawerProps> = ({
	isOpen,
	onClose,
	t,
	drawerWidth,
	onDrawerWidthChange,
	isResizing,
	onResizingChange,
	deliberation
}) => {
	const drawerRef = React.useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleMouseMove = (e: MouseEvent) => {
			if (!isResizing) return;

			const newWidth = window.innerWidth - e.clientX;
			if (newWidth > 200 && newWidth < 600) {
				onDrawerWidthChange(newWidth);
			}
		};

		const handleMouseUp = () => {
			onResizingChange(false);
		};

		if (isResizing) {
			document.addEventListener('mousemove', handleMouseMove);
			document.addEventListener('mouseup', handleMouseUp);
		}

		return () => {
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseup', handleMouseUp);
		};
	}, [isResizing, onDrawerWidthChange, onResizingChange]);

	if (!isOpen) return null;

	return (
		<div
			ref={drawerRef}
			className="h-full bg-white fixed right-0 top-0 bottom-0 "
			style={{
				width: `${drawerWidth}px`,
				height: '100vh',
				zIndex: 99
			}}
		>
			<div className="flex flex-col h-full">
				<div
					className="absolute left-0 top-0 bottom-0 w-1 cursor-ew-resize group flex items-center"
					onMouseDown={() => onResizingChange(true)}
				>
					<div className="absolute left-0 top-0 bottom-0 w-1 bg-gray-200 group-hover:bg-brand-600 transition-colors duration-200" />
					<div
						className="absolute left-0 w-4 h-8 -ml-2 top-1/2 -translate-y-1/2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200"
						style={{ backgroundColor: 'rgba(30, 96, 145, 0.1)' }}
					>
						<div className="h-full w-full flex items-center justify-center">
							<div className="w-0.5 h-4 bg-brand-600 mx-0.5" />
							<div className="w-0.5 h-4 bg-brand-600 mx-0.5" />
						</div>
					</div>
				</div>

				<div className="flex-none p-4 border-b bg-white sticky top-0 z-10">
					<div className="flex justify-between items-center">
						<Typography size="lg" weight="semibold">
							{t('ViewDeliberation')}
						</Typography>
						<button
							onClick={onClose}
							className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
						>
							<X size={24} color={BRAND_COLORS.brand600} />
						</button>
					</div>
				</div>

				<div className="flex-1 overflow-y-auto">
					<div className="flex flex-col px-3 mt-5">
						<Typography size="md">{deliberation}</Typography>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DeliberationDrawer;
